import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { MdOutlineInfo } from 'react-icons/md';
import { GetAndCreateRfq } from '../../../../../services/ProductService/AllProductList/AllProductServices';

const HighDemandEnquiriesBanner = ({ RfqSelectedIds }) => {

  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const getSelectedRfqDatas = async (ids) => {
    try {
      const response = await GetAndCreateRfq('GET', {});
      const allRfqs = response.data || [];

      // Filter RFQs that match the selected IDs
      const selectedRfqs = allRfqs.filter((item) => ids.includes(item.id));
      setEnquiries(selectedRfqs);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (RfqSelectedIds && RfqSelectedIds.length > 0) {
      getSelectedRfqDatas(RfqSelectedIds);
    }
  }, [RfqSelectedIds]);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold text-gray-500 mb-2">Manage High Demand / Hot Enquiries</h2>
      <p className="text-sm mb-4">
        You can manage all website <span className="text-red-500 font-semibold">“ High Demand / Hot Enquiries ”</span> Here
      </p>

      <div className="bg-white shadow px-5 py-10 mt-10  border rounded-lg">
        {loading ? (
          <p className='text-center font-bold text-xl text-gray-500'>Loading enquiries...</p>
        ) : (<>
          <div className="flex items-center text-lg justify-center font-semibold mb-4">
            <MdOutlineInfo className="mr-2" />
            High Demand / Hot Enquiries
          </div>
          <div className="grid grid-flow-col grid-rows-2 gap-5 overflow-x-auto w-[1140px] mx-8">
            {enquiries.map((item, idx) => (
              <div key={idx} className="border-2 border-gray-200 rounded-lg p-4 shadow-sm w-[550px]">
                <div className="flex justify-between text-sm mb-2">
                  <span className="flex items-center gap-2">
                    {item.country_name.slice(0, 3).toUpperCase()}<span className="text-blue-600">Wanted : {item.product_name}</span>
                  </span>
                  {/* <span className="text-gray-500">{item.date}</span> */}
                </div>

                <div className="flex items-center text-sm font-semibold mb-2">
                  Buyer From {item.country_name}
                  <span className="text-blue-600 flex items-center gap-1 ml-2">
                    <FaCheckCircle className="text-blue-600" /> Verified
                  </span>
                  {/* <span className="ml-2 text-orange-500 text-xs">{item.rating} / 5 review</span> */}
                </div>

                <p className="text-sm text-gray-700">
                  {item.short_description}
                  {/* {item.more && (
                    <span className="text-blue-600 ml-1 cursor-pointer">More</span>
                  )} */}
                </p>
              </div>
            ))}
          </div>
        </>)}
      </div>
    </div>
  );
};

export default HighDemandEnquiriesBanner;
